import classNames from 'classnames';

import { ZoomVideoContainerProps } from './zoomVideoContainer.types';

/**
 * Wrapper for Zoom SDK custom element `video-player-container`.
 * Centralizes the type assertion required for the custom element.
 */
const ZoomVideoContainer = ({ className, id }: ZoomVideoContainerProps) => {
  return (
    /* @ts-expect-error Zoom Video SDK custom element; not in DOM types */
    <video-player-container id={id} className={classNames('size-full', className)} />
  );
};

export default ZoomVideoContainer;
